import { FC } from 'react';

import { useTheme } from 'styled-components';

import { Typography } from '@libs/components';

import { FlexWrapper } from './styles';

type OptionsIconWrapperProps = {
  firstIcon: JSX.Element | string;
  secondIcon: JSX.Element | string;
  className?: string;
};
const IconPairWithDivider: FC<OptionsIconWrapperProps> = ({
  firstIcon,
  secondIcon,
  className,
}) => {
  const { colors } = useTheme();

  return (
    <FlexWrapper className={className}>
      {typeof firstIcon === 'string' ? <img src={firstIcon} /> : firstIcon}
      <Typography color={colors.text.secondary} type="headline">
        /
      </Typography>
      {typeof secondIcon === 'string' ? <img src={secondIcon} /> : secondIcon}
    </FlexWrapper>
  );
};

export default IconPairWithDivider;
